import { Injectable } from "@angular/core";
import { Store, select } from '@ngrx/store';
import { IPlannedPortfolio } from 'src/app/models/plannedPortfolios';
import { IAppState } from './../../state/app.state';
import { SelectPlannedPortfolio, SelectTemporaryPlannedPortfolio, CancelTemporaryPlannedPortfolio, SubmitPlannedPortfolio, ResetPlannedPortfolio, SetSelectedSubscriptionId } from './../actions/planned-portfolios.actions';
import { IPlannedPortfolioPayload } from '../../../models/plannedPortfolios';
import { getSelectedPlannedPortfolio, getSelectedPlannedIds, selectSelectedSubscriptionId, getPlannedPortfoliosState } from '../selectors/planned-portfolios.selectors';
import { getSelectedTempPlannedportfolio, selectLoadingPlannedPortfolio, getTempPlannedPortfoliosState, getSelectedTempPlannedIds, selectPlannedPortfolioDataError, selectTempLoadingPlannedPortfolio } from '../selectors/temp-planned-portfolios.selectors';

@Injectable()
export class PlannedPortfoliosFacade {

    private _selectedPlannedPortfolioIds: number[] = [];
    private _selectedTempPlannedPortfolioIds: number[] = [];

    public selectedPlannedPortfolio$ = this.store.pipe(
        select(getSelectedPlannedPortfolio)
    );

    public selectedPlannedPortfolioIds$ = this.store.pipe(
        select(getSelectedPlannedIds)
    ).subscribe((selectedPlannedPortfolioIds: number[]) => {
        this._selectedPlannedPortfolioIds = selectedPlannedPortfolioIds;
    });
    public selectedTempPlannedPortfolioIds$ = this.store.pipe(
        select(getSelectedTempPlannedIds)
    ).subscribe((selectedTempPlannedPortfolioIds: number[]) => {
        this._selectedTempPlannedPortfolioIds = selectedTempPlannedPortfolioIds;
    });

    public selectedTempPlannedPortfolio$ = this.store.pipe(
        select(getSelectedTempPlannedportfolio)
    );

    public selectLoadingPlannedPortfolio$ = this.store.pipe(
        select(selectLoadingPlannedPortfolio)
    );

    public selectTempLoadingPlannedPortfolio$ = this.store.pipe(
        select(selectTempLoadingPlannedPortfolio)
    );

    public selectedPlannedPortfolioState$ = this.store.pipe(
        select(getPlannedPortfoliosState)
    );

    public selectedTempPlannedPortfolioState$ = this.store.pipe(
        select(getTempPlannedPortfoliosState)
    );

    public plannedModelPortfolioDataError$ = this.store.pipe(
        select(selectPlannedPortfolioDataError)
    );

    public selectedSubscriptionId$ = this.store.pipe(
        select(selectSelectedSubscriptionId)
    );

    constructor(private store: Store<IAppState>) { }

    public getPlannedPortfolio(portfolioId: number, modelPortfolioId: number, subscriptionId: number) {
        const plannedPortfolioPayload: IPlannedPortfolioPayload = {
            modelPortfolioId: modelPortfolioId,
            subscriptionId: subscriptionId
        };
        this.store.dispatch(new SelectPlannedPortfolio(plannedPortfolioPayload));
    }

    public cancelTempPlannedPortfolio(subscriptionId: number) {
        this.store.dispatch(new CancelTemporaryPlannedPortfolio(subscriptionId));
    }

    public doesSelectedPlannedPortfolioExist(subscriptionId: number) {
        return this._selectedPlannedPortfolioIds.includes(subscriptionId);
    }

    public doesSelectedTempPlannedPortfolioExist(subscriptionId: number) {
        return this._selectedTempPlannedPortfolioIds.includes(subscriptionId);
    }

    public submitPlannedPortfolio(plannedPortfolio: IPlannedPortfolio) {
        this.store.dispatch(new SubmitPlannedPortfolio(plannedPortfolio));
    }

    public getTemporaryPlannedPortfolio(temporaryPlannedPortfolioPayload: IPlannedPortfolio) {
        this.store.dispatch(new SelectTemporaryPlannedPortfolio(temporaryPlannedPortfolioPayload));
    }

    public resetPlannedPortfolio() {
        this.store.dispatch(new ResetPlannedPortfolio());
    }
    public setSelectedSubscriptionId(subscriptionId: number) {
        this.store.dispatch(new SetSelectedSubscriptionId(subscriptionId));
    }


}
